import styled from 'styled-components';

export const SuggestionBlock = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  & > a {
    width: 55px;
    position: absolute;
    top: 35%;
    left: auto;
    z-index: 2;

    & > svg {
      position: absolute;
      left: auto;
      top: 35%;
      cursor: pointer;
      z-index: 1;
    }
  }

  & > .url {
    width: 100%;
    position: relative;
    top: 0; 
    z-index: 0;
    cursor: pointer;
  }

  & > img {
    width: 100%;
    height: auto;
  }

  & > video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    @media screen and (orientation: portrait) {
      max-height: 55%;
    }
  }

  & > .mediaVideo {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    @media screen and (orientation: portrait) {
      max-height: 100%;
    }
  }

  & > div {
    position: absolute;
    width: 100%;
    max-width: 88%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    bottom: -213px;
    background: #fff;
    padding: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    @media screen and (orientation: portrait) {
      position: relative;
      padding: 15px;
      padding-bottom: 20px;
      max-width: 100%;
      bottom: 0;
    }

    & > span {
      color: #000;
      text-align: center;
      font-size: 11px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 1px;
      text-transform: uppercase;
      padding-bottom: 9px;
      @media screen and (orientation: portrait) {
        font-size: 9px;
      }
    }

    & > h3.mainHeading {
      color: #000;
      text-align: center;
      font-family: "Inconsolata", serif;
      font-size: 20px;
      font-weight: 700;
      line-height: 25px;
      letter-spacing: 0.68px;
      text-transform: uppercase;
      @media screen and (orientation: portrait) {
        line-height: 17px;
        font-size: 14px;
        font-weight: 400;
      }
    }
    & > h3.mainHeadingSmall {
      color: #000;
      text-align: center;
      font-family: "Inconsolata", serif;
      font-size: 18px;
      font-weight: 500;
      line-height: 25px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      @media screen and (orientation: portrait) {
        line-height: 20px;
        font-size: 14px;
        font-weight: 400;
      }
    }

    & > p {
      width: 100%;
      color: rgba(0, 0, 0, 0.7);
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.48px;
      margin-top: 15px;
      margin-bottom: 25px;
    }

    & > div {
      display: flex;
      column-gap: 20px;
      @media screen and (orientation: portrait) {
        flex-direction: column;
        column-gap: 0;
        row-gap: 10px;
        align-items: center;
      }
    }

    & a,
    & .btn {
      width: max-content;
      height: 33px;
      border-radius: 50px;
      border: 1px solid #ddd;
      background: #000;
      color: #fff;
      text-align: center;
      font-family: "Inconsolata", serif;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0.77px;
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  & > .Blk_D {
    width: 100%;
    display: flex;
    position: relative;
    bottom: 0;
    max-width: 100%;
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
    align-items: flex-start;
    padding-top: 20px;
    & > span {
      font-size: 14px;
      font-weight: 300;
      color: #000;
      padding-bottom: 0;
      text-transform: none;
      letter-spacing: 0;
      text-align: left;
      @media screen and (orientation: portrait) {
        font-size: 12px;
        font-weight: 400;
      }
    }
    @media screen and (orientation: portrait) {
      padding-top: 12px;
      padding-left: 0;
      padding-right: 0;
    }
  }
  @media screen and (orientation: portrait) {
    margin-bottom: 0;
    flex-direction: column;
  }

  & .top_line {
    @media screen and (orientation: portrait) {
      display: none;
    }
  }
`;
